import React from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import useSev2TaskCombobox from './hooks';

export const Sev2TaskComboboxSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      title: { type: 'string', title: 'Title', default: 'Task' },
      description: {
        type: 'string',
        title: 'Description',
        default: 'Select a task',
      },
    },
  },
  returnValue: { type: 'object' },
};

export const Sev2TaskCombobox = (
  props: FieldExtensionComponentProps<
  { name?: string; phid?: string },
  { title: string; description: string }
  >,
) => {
  const { onChange, rawErrors, required, formData, formContext, uiSchema } = props;
  const projectPhid: string | undefined = formContext.formData?.project?.phid;


  const { loading, open, setOpen, options, searchTask } =
    useSev2TaskCombobox(projectPhid);

  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors?.length > 0 && !formData}
    >
      <Autocomplete
        id="combo-box-task"
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onInputChange={(_, value) => {
          searchTask(value);
        }}
        onChange={(_, value) => {
          onChange({ name: value?.fields?.name, phid: value?.phid });
        }}
        getOptionSelected={(option, value) => option.phid === value.phid}
        getOptionLabel={value => `[T${value?.id}] - ${value?.fields?.name}`}
        options={options}
        loading={loading}
        renderInput={params => (
          <TextField
            {...params}
            label={uiSchema?.['ui:options']?.title}
            variant="standard"
            helperText={uiSchema?.['ui:options']?.description}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
};